export const activePolicyNumbers = (state) => state.activePolicyNumbers;

export const excessTotal = (state) => state.excessTotal;

export const excessRemaining = (state) => state.excessRemaining;
export const loadingPolicies = (state) => state.loadingPolicies;
